<template>
  <div class="app__slider-year">
    <ul class="slider-year__container">
      <li class="slider-year__item"></li>
      <li class="slider-year__item">1997</li>
      <li class="slider-year__item">1998</li>
      <li class="slider-year__item">2001</li>
      <li class="slider-year__item">2004</li>
      <li class="slider-year__item">2010</li>
      <li class="slider-year__item">2011</li>
      <li class="slider-year__item">2018</li>
      <li class="slider-year__item">2019</li>
    </ul>
    <button
      aria-label="slider prev page"
      class="slider-year__prev"
      @click="$eventHub.$emit('swipeClick', { direction: 4 })"
    />
    <button
      aria-label="slider next page"
      class="slider-year__next"
      @click="$eventHub.$emit('swipeClick', { direction: 2 })"
    />
  </div>
</template>

<script>
export default {
  name: 'Slider',
};
</script>

<style lang="scss" scoped>
.app__slider-year {
  position: absolute;
  bottom: 55px;
  left: 0;
  width: 100%;
  font-size: font-size(l);

  z-index: 30;

  @include mq(ipadL) {
    @include visually-hidden;
  }

  & .slider-year__prev,
  & .slider-year__next {
    position: absolute;
    top: 0;
    width: 20vw;
    height: 100%;
    margin: 0;
    padding: 0;

    background-color: transparent;
    border-radius: 0;
    border: none;

    &:focus {
      outline: transparent;
    }
  }

  & .slider-year__prev {
    left: 0;
  }

  & .slider-year__next {
    right: 0;
  }

  & .slider-year__container {
    position: relative;
    width: 100%;
    height: 50px;
    line-height: 50px;
    overflow: hidden;

    li {
      position: absolute;

      display: inline-block;
      transform: translateX(-50%);
    }
  }
}
</style>
